import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import { MdCheck, MdPriorityHigh, MdLock } from "react-icons/md";
import Label from "shared/components/Label";
import {
  filterTextField,
  normalizeTextField,
  stripTrailingSpaces,
} from "utils/helpers/validations";

const Simple = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  labelSuffix,
  innerRef,
  required,
  direction,
  optional,
  right,
  trim = false,
  normalizeText = false,
  success,
  showSuccessIcon = true,
  className,
  ...rest
}) => {
  const { onChange, onKeyUp, onBlur, onPaste, ...inputRest } = rest;

  const cleanTrimValue = (value) =>
    value == null ? "" : String(value).replace(/[^a-z0-9]/gi, "");

  const applyTrim = (e) => {
    if (!trim) return;
    const cleaned = cleanTrimValue(e.target.value);
    if (cleaned === e.target.value) return;
    e.target.value = cleaned;
    onChange?.({ ...e, target: { ...e.target, value: cleaned } });
  };

  const handleChange = (e) => {
    if (normalizeText) {
      const cleaned = filterTextField(e.target.value);
      if (cleaned !== e.target.value) {
        e = { ...e, target: { ...e.target, value: cleaned } };
      }
    }
    onChange?.(e);
  };

  const handleBlur = (e) => {
    if (normalizeText) {
      const cleaned = normalizeTextField(e.target.value);
      if (cleaned !== e.target.value) {
        e.target.value = cleaned;
        e = { ...e, target: { ...e.target, value: cleaned } };
        onChange?.(e);
      }
    }
    const type = String(rest.type || "text").toLowerCase();
    if (type !== "password" && type !== "hidden") {
      const stripped = stripTrailingSpaces(e.target.value);
      if (stripped !== e.target.value) {
        e.target.value = stripped;
        e = { ...e, target: { ...e.target, value: stripped } };
        onChange?.(e);
      }
    }
    applyTrim(e);
    onBlur?.(e);
  };

  const hasValue =
    rest.value !== undefined &&
    rest.value !== null &&
    `${rest.value}`.trim() !== "";

  return (
    <div
      className={classnames(
        "input__wrapper",
        {
          __error: touched && errors,
          __success: success && !errors,
        },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        labelSuffix={labelSuffix}
        required={required}
        optional={optional}
        right={right}
      />
      <div className={`input__wrapper--field`}>
        <Input
          className={classnames(
            className,
            {
              "input--borderd--red": touched && errors,
              "disable--input": rest.disabled,
              "input--filled": hasValue,
            },
          )}
          placeholder={placeholder}
          ref={innerRef}
          {...inputRest}
          onChange={handleChange}
          onKeyUp={(e) => {
            onKeyUp?.(e);
            applyTrim(e);
          }}
          onPaste={(e) => {
            onPaste?.(e);
            requestAnimationFrame(() => handleChange(e));
          }}
          onBlur={handleBlur}
        />

        {/* Icône d'erreur */}
        {touched && errors && (
          <MdPriorityHigh
            className="input--error-icon"
            size={20}
          />
        )}

        {/* Icône de succès */}
        {success && showSuccessIcon && !errors && (
          <MdCheck
            className="input--success-icon"
            size={20}
          />
        )}

        {/* Icône cadenas pour disabled */}
        {rest.disabled && !touched && (
          <MdLock
            className="input--disabled-icon"
            size={16}
          />
        )}
      </div>
      {touched && errors && <p className={"input--errors"}>{errors}</p>}
    </div>
  );
};

Simple.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  icon: PropTypes.node,
  required: PropTypes.bool,
  optional: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  success: PropTypes.bool,
  showSuccessIcon: PropTypes.bool,
};

Simple.defaultProps = {
  label: "",
  placeholder: "",
  showSuccessIcon: true,
};
export default Simple;
